import { createContext } from 'react'

export type ContextType = {
    isIntersecting: boolean
}

export const Context = createContext<ContextType>({ isIntersecting: false })
